import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Link, Stack, Paper, TextField, Box, Grid, Typography, Card, TableCell, TableContainer,
    Table, InputAdornment, TableHead, Button, IconButton, FormControl, CardContent, DialogContent, DialogTitle, Dialog,
    InputLabel, TableRow, TableBody, Snackbar, CircularProgress, AccordionDetails, MenuItem, Checkbox, Autocomplete, Tooltip, FormControlLabel, Accordion, AccordionSummary, Menu
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import SaveIcon from '@mui/icons-material/Save';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import { addProformaInvoice, addPurchaseInvoice, addSaleInvoice, editDeleteProformaInvoice, editDeletePurchaseInvoice, editDeleteSaleInvoice, getCNSList, getItemList, getProformaItemDescriptionForManualEntry, getSalesItemDescriptionForManualEntry, getTermsConditionsList, getUnitList, } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';
import { dateConversionOnEntryPage, dateConversionOnEntryPageWithTime } from '../../reusableComponent/dateConversionOnEntryPage';
import { financialYear } from '../../reusableComponent/financialYear';
import { convertStringIntoTitleCase } from '../../reusableComponent/convertStringIntoTitleCase';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

function ProformaInvoiceAdd(props) {
    // const editInfo = props.details;
    const urlLocation = useLocation();
    const prName = urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const invoiceSetting = urlLocation.state.invoiceSettingList && urlLocation.state.invoiceSettingList[0];
    const backBtnLen = urlLocation.state.backBtn;
    const docNoFormateAvailable = urlLocation.state.docNoFormateAvailable;
    const termsList = urlLocation.state.termsList;
    const [billAddress, setBillAddress] = useState({});

    const dispatch = useDispatch();
    const classes = useStyles();
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const editData = editInfo && editInfo;
    const editid = editData ? editData.pi_id : null;
    const [isUpdateArray, setIsUpdateArray] = useState(false);

    const [customerName, setCustomerName] = useState(editData ? editData.customerName : prName ? prName : null);
    const [successMessage, setSuccessMessage] = useState(null);

    const customerList = useSelector(state => state.CNS.CNS)
    const unitList = useSelector(state => state.unit.unit)
    const itemList = useSelector(state => state.item.item)
    const sales_itemDescription_forManualEntryList = useSelector(state => state.ProformaInvoice.proforma_itemDescription_forManualEntry)

    // const termsList = useSelector(state => state.termsConditions.termsConditions)
    const availTermsList = editData ? JSON.parse(editData.invoice_terms) : [];
    const [rowsTerms, setRowsTerms] = useState([]);

    const [isSet, setIsSet] = useState(false);
    const [invoiceDate, setInvoiceDate] = React.useState(editData ? dayjs(editData.invoiceDate) : dayjs(new Date()));
    const [challanDate, setChallanDate] = React.useState(editData ? dayjs(editData.challanDate) : dayjs(new Date()));
    const [orderRefDate, setOrderRefDate] = React.useState(editData ? dayjs(editData.orderRefDate) : dayjs(new Date()));

    const [basicTotal, setBasicTotal] = useState(editData ? editData.basicTotal : 0);
    const [gst, setGSt] = useState(editData ? editData.gst : 0);   // single gst %, if multiple tthen remove this
    const [gstTotal, setGstTotal] = useState(editData ? editData.gstTotal : 0);
    const [cgst, setCgst] = useState(editData ? editData.cgst : 0);
    const [sgst, setSgst] = useState(editData ? editData.sgst : 0);
    const [igst, setIgst] = useState(editData ? editData.igst : 0);
    const [cgstTotal, setCgstTotal] = useState(editData ? editData.cgstTotal : 0);
    const [sgstTotal, setSgstTotal] = useState(editData ? editData.sgstTotal : 0);
    const [igstTotal, setIgstTotal] = useState(editData ? editData.igstTotal : 0);

    const [total, setTotal] = useState(editData ? editData.total : 0);
    const [round_off, setRound_off] = useState(editData ? editData.round_off : 0);

    const [totalDiscountPer, setTotalDiscountPer] = useState(editData ? editData.totalDiscountPer : 0);
    const [totalDiscountAmt, setTotalDiscountAmt] = useState(editData ? editData.totalDiscountAmt : 0);
    const [assessableAmt, setAssessableAmt] = useState(editData ? editData.assessableAmt : 0);
    const [packing_forwarding, setPacking_forwarding] = useState(editData ? editData.packing_forwarding : 0);
    const [freight_charges, setFreight_charges] = useState(editData ? editData.freight_charges : 0);
    const [tempo_charges, setTempo_charges] = useState(editData ? editData.tempo_charges : 0);
    const [other_charges, setOther_charges] = useState(editData ? editData.other_charges : 0);
    const [discount_show, setDiscount_show] = useState(editData ? editData.discount_show : 0);
    const [packing_forwarding_show, setPacking_forwarding_show] = useState(editData ? editData.packing_forwarding_show : 0);
    const [freight_charges_show, setFreight_charges_show] = useState(editData ? editData.freight_charges_show : 0);
    const [tempo_charges_show, setTempo_charges_show] = useState(editData ? editData.tempo_charges_show : 0);
    const [other_charges_show, setOther_charges_show] = useState(editData ? editData.other_charges_show : 0);
    

    const [data, setData] = useState({
        id: editid,
        challanNo: editData ? editData.challanNo : '',
        invoiceType: editData ? editData.invoiceType : 'SALE',
        eWayBillNo: editData ? editData.eWayBillNo : '',
        asnNo: editData ? editData.asnNo : '',
        modeOfTransport: editData ? editData.modeOfTransport : '',
        vehicleNo: editData ? editData.vehicleNo : '',
        paymentTerms: editData ? editData.paymentTerms : 30,
        contactPerson: editData ? editData.contactPerson : '',
        contactNo: editData ? editData.contactNo : '',
        basicTotal: editData ? editData.basicTotal : 0,
        gstTotal: editData ? editData.gstTotal : 0,
        total: editData ? editData.total : 0,
        remark: editData ? editData.remark : '',
        orderRefNo: editData ? editData.orderRefNo : '',
        accountManagerName: editData ? editData.accountManagerName : '',
    });

    const [inputFields, setInputFields] = useState(
        editData ? JSON.parse(editData.childRows) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
                cgstAmount: 0,
                sgstAmount: 0,
                igstAmount: 0,
                basicAmount: 0,
                assessableAmt: 0,
                amount: 0,
                noOfPkg: '',
                batchNo: '',
                discountPer: 0,
                discountAmt: 0,
            },
            ]);

    const handleChangeTerms = (event, index) => {
        const updatedFields = [...rowsTerms];
        updatedFields[index].trueFalse = event.target.checked;
        setRowsTerms(updatedFields);
        setIsUpdateArray(isUpdateArray ? false : true);
    };

    const handleChangeCustomer = (event, newValue) => {
        setCustomerName(newValue)
        setBillAddress({
            contact_no: newValue == null ? null : newValue.mobileNo,
            address: newValue == null ? null : newValue.address,
            city: newValue == null ? null : newValue.city,
            pinCode: newValue == null ? null : newValue.pinCode,
            contact_person: newValue == null ? null : newValue.contactPerson,
            gstn: newValue == null ? null : newValue.gstn,
        })

        dispatch(getProformaItemDescriptionForManualEntry({ companyId: userInfo.companyId, customerName: newValue == null ? null : newValue.CSNId }))

        const custState = newValue ? convertStringIntoTitleCase(newValue.state) : null;

        if (invoiceSetting.showGstPer_details === 'true') {
            setInputFields([{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
                cgstAmount: 0,
                sgstAmount: 0,
                igstAmount: 0,
                basicAmount: 0,
                amount: 0,
                noOfPkg: '',
                batchNo: '',
                discountPer: 0,
                discountAmt: 0,
            }])
            setBasicTotal(parseFloat(0));
            setAssessableAmt(parseFloat(0));
            setCgstTotal(parseFloat(0));
            setCgstTotal(parseFloat(0));
            setSgstTotal(parseFloat(0));
            setIgstTotal(parseFloat(0));
            // handleInvoiceCalculation(0, custState, packing_forwarding, freight_charges, tempo_charges, other_charges, gst, totalDiscountPer)
            handleInvoiceCalculationGSTinDetails(0, 0, 0, 0, 0, 0, packing_forwarding, freight_charges, tempo_charges, other_charges)

        }

        if (invoiceSetting.showGstPer_header === 'true') {
            handleInvoiceCalculation(basicTotal, custState, packing_forwarding, freight_charges, tempo_charges, other_charges, gst, totalDiscountPer)
        }

    }


    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
        setIsSet(isSet ? false : true)


    }

    const handleRemoveFields = (ind) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value, i) => i === ind),
            1
        );
        setInputFields(values);

        setIsUpdateArray(isUpdateArray ? false : true);

        const reducer = (previousValue, currentValue) => previousValue + currentValue;
        if (invoiceSetting.showGstPer_details === 'true') {
            const bsAmt = values.length > 0 && values.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
            const asAmt = values.length > 0 && values.map(value => value.assessableAmt && value.assessableAmt ? parseFloat(value.assessableAmt) : 0).reduce(reducer);
            const gstAmt = values.length > 0 && values.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
            const cgstA = values.length > 0 && values.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
            const sgstA = values.length > 0 && values.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
            const igstA = values.length > 0 && values.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);
            setBasicTotal(parseFloat(bsAmt));
            setAssessableAmt(parseFloat(asAmt));
            setCgstTotal(parseFloat(gstAmt));
            setCgstTotal(parseFloat(cgstA));
            setSgstTotal(parseFloat(sgstA));
            setIgstTotal(parseFloat(igstA));
            setIsUpdateArray(isUpdateArray ? false : true);
            setIsSet(isSet ? false : true);
            handleInvoiceCalculationGSTinDetails(bsAmt, asAmt, gstAmt, cgstA, sgstA, igstA, packing_forwarding, freight_charges, tempo_charges, other_charges)
        } else {
            const amount1 = values.length > 0 && values.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
            let basicAmt = parseFloat(amount1);
            setBasicTotal(parseFloat(basicAmt));
            setIsUpdateArray(isUpdateArray ? false : true);
            setIsSet(isSet ? false : true)

            handleInvoiceCalculation(basicAmt, customerName.state, packing_forwarding, freight_charges, tempo_charges, other_charges, gst, totalDiscountPer)
        }
    };

    const handleChangeDiscount_show = ({ target }) => {
        let value = target.checked;
        setDiscount_show(value == true ? 1 : 0);
    }
    const handleChangePacking_forwarding_show = ({ target }) => {
        let value = target.checked;
        setPacking_forwarding_show(value == true ? 1 : 0);
    }
    const handleChangeFreight_charges_show = ({ target }) => {
        let value = target.checked;
        setFreight_charges_show(value == true ? 1 : 0);
    }
    const handleChangeTempo_charges_show = ({ target }) => {
        let value = target.checked;
        setTempo_charges_show(value == true ? 1 : 0);
    }
    const handleChangeOther_charges_show = ({ target }) => {
        let value = target.checked;
        setOther_charges_show(value == true ? 1 : 0);
    }

    const handleChangeGST = (e) => {
        setGSt(e.target.value)

        handleInvoiceCalculation(basicTotal, customerName?.state || null, packing_forwarding, freight_charges, tempo_charges, other_charges, e.target.value, totalDiscountPer)
    }

    const handleChangeTotalDiscountPer = (e) => {
        setTotalDiscountPer(e.target.value)
        handleInvoiceCalculation(basicTotal, customerName?.state || null, packing_forwarding, freight_charges, tempo_charges, other_charges, gst, e.target.value)
    }
    const handleChangePackingForwarding = (e) => {
        setPacking_forwarding(e.target.value)
        if (invoiceSetting.showGstPer_details === 'true') {
            handleInvoiceCalculationGSTinDetails(basicTotal, assessableAmt, gstTotal, cgstTotal, sgstTotal, igstTotal, e.target.value, freight_charges, tempo_charges, other_charges)
        } else {
            handleInvoiceCalculation(basicTotal, customerName?.state || null, e.target.value, freight_charges, tempo_charges, other_charges, gst, totalDiscountPer)
        }
    }
    const handleChangeFreightCharges = (e) => {
        setFreight_charges(e.target.value)
        if (invoiceSetting.showGstPer_details === 'true') {
            handleInvoiceCalculationGSTinDetails(basicTotal, assessableAmt, gstTotal, cgstTotal, sgstTotal, igstTotal, packing_forwarding, e.target.value, tempo_charges, other_charges)
        } else {
            handleInvoiceCalculation(basicTotal, customerName?.state || null, packing_forwarding, e.target.value, tempo_charges, other_charges, gst, totalDiscountPer)
        }
    }
    const handleChangeTempoCharges = (e) => {
        setTempo_charges(e.target.value)
        if (invoiceSetting.showGstPer_details === 'true') {
            handleInvoiceCalculationGSTinDetails(basicTotal, assessableAmt, gstTotal, cgstTotal, sgstTotal, igstTotal, packing_forwarding, freight_charges, e.target.value, other_charges)
        } else {
            handleInvoiceCalculation(basicTotal, customerName?.state || null, packing_forwarding, freight_charges, e.target.value, other_charges, gst, totalDiscountPer)
        }
    }

    const handleChangeOtherCharges = (e) => {
        setOther_charges(e.target.value)
        if (invoiceSetting.showGstPer_details === 'true') {
            handleInvoiceCalculationGSTinDetails(basicTotal, assessableAmt, gstTotal, cgstTotal, sgstTotal, igstTotal, packing_forwarding, freight_charges, tempo_charges, e.target.value)
        } else {
            handleInvoiceCalculation(basicTotal, customerName?.state || null, packing_forwarding, freight_charges, tempo_charges, e.target.value, gst, totalDiscountPer)
        }
    }

    const handleChangeInvoiceDate = (newValue) => {
        setInvoiceDate(newValue);
    };

    const handleChangeChallanDate = (newValue) => {
        setChallanDate(newValue);
    };

    const handleChangePoDate = (newValue) => {
        setOrderRefDate(newValue);
    };

    const supplierGetData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer' }));
    }
    const unitGetData = () => {
        dispatch(getUnitList({ companyId: userInfo.companyId }));
    }
    const itemGetData = () => {
        dispatch(getItemList({ companyId: userInfo.companyId }));
    }
    // const termsConditions = () => {
    //     dispatch(getTermsConditionsList({ companyId: userInfo.companyId, terms: 'Proforma Invoice' }));
    // }

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.ProformaInvoice.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Proforma Invoice already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        // let TermsLength = rowsTerms.filter((n) => n.trueFalse === true)
        // if (TermsLength.length === 0) {
        //     alert("Please select at least one TERMS & CONDITIONS to create invoice!")
        // } else {
        if (docNoFormateAvailable && docNoFormateAvailable.length === 0) {
            alert("Please enter Document No Format")
        } else {
            let saleInvoiceData = {
                ...data,
                invoiceDate: dateConversionOnEntryPage(invoiceDate),
                challanDate: dateConversionOnEntryPage(challanDate),
                orderRefDate: dateConversionOnEntryPage(orderRefDate),
                childRows: inputFields,
                gst: gst,
                basicTotal: basicTotal,
                gstTotal: gstTotal,
                cgst: cgst,
                sgst: sgst,
                igst: igst,
                cgstTotal: cgstTotal,
                sgstTotal: sgstTotal,
                igstTotal: igstTotal,
                total: total,
                round_off: round_off,
                pendingAmount: total,
                totalDiscountPer: totalDiscountPer,
                totalDiscountAmt: totalDiscountAmt,
                assessableAmt: assessableAmt,
                packing_forwarding: packing_forwarding,
                freight_charges: freight_charges,
                tempo_charges: tempo_charges,
                other_charges: other_charges,
                discount_show: discount_show,
                packing_forwarding_show: packing_forwarding_show,
                freight_charges_show: freight_charges_show,
                tempo_charges_show: tempo_charges_show,
                other_charges_show: other_charges_show,
                companyId: userInfo.companyId,
                customerName: customerName.CSNId,
                billAddress: billAddress,
                rowsTerms: rowsTerms,
                finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, invoiceDate.$M, invoiceDate.$y),
                createdBy: editData ? editData.createdBy : userInfo.userId,
                createdAt: editData ? editData.createdAt : dateConversionOnEntryPageWithTime(new Date()),
                modifiedBy: editData ? userInfo.userId : null,
                modifiedAt: editData ? dateConversionOnEntryPageWithTime(new Date()) : '',
                changedUpdatedValue: 'edit'
            }

            if (editData) {
                dispatch(editDeleteProformaInvoice(saleInvoiceData));
            } else {
                dispatch(addProformaInvoice(saleInvoiceData));
            }
        }
        // }
    }

    useEffect(() => {
        supplierGetData()
        itemGetData()
        unitGetData()

        if (editData) {

            setCustomerName({
                CNS_Name: editData.CNS_Name,
                CSNId: editData.customerName,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                pinCode: editData.pinCode,
                state: editData.state,
            })
            const billing = JSON.parse(editData.billAddress)
            setBillAddress({
                contact_no: billing.mobileNo,
                address: billing.address,
                city: billing.city,
                pinCode: billing.pinCode,
                contact_person: billing.contactPerson,
                gstn: billing.gstn,
            })

            const newArr = []
            JSON.parse(editData.childRows).map((row) => (
                newArr.push({
                    itemId: row,
                    itemCode: row.itemCode,
                    // itemId: row.itemId,
                    itemName: row.itemName,
                    itemDescription: row.itemDescription,
                    hsnCode: row.hsnCode,
                    quantity: row.quantity,
                    unit: row,
                    rate: row.rate,
                    gst: row.gst,
                    cgst: row.cgst,
                    sgst: row.sgst,
                    igst: row.igst,
                    gstAmount: row.gstAmount,
                    cgstAmount: row.cgstAmount,
                    sgstAmount: row.sgstAmount,
                    igstAmount: row.igstAmount,
                    basicAmount: row.basicAmount,
                    assessableAmt: row.assessableAmt,
                    amount: row.amount,
                    noOfPkg: row.noOfPkg,
                    batchNo: row.batchNo,
                    discountPer: row.discountPer,
                    discountAmt: row.discountAmt,
                })
            ))

            setInputFields(newArr)
        }

    }, []);

    useEffect(() => {

    }, [termsList, availTermsList])

    useEffect(() => {
        const initialInputFields = termsList && termsList.map((r, index) => ({
            id: uuidv4(),
            termsAndConditions: r.termsAndConditions,
            trueFalse: editid === null ? true : availTermsList.find((n) => n.termsAndConditions === r.termsAndConditions).trueFalse,
        }));
        setRowsTerms(initialInputFields);
    }, [])


    // const [suggestions, setSuggestions] = useState([]);
    const [suggestions, setSuggestions] = useState(Array(inputFields && inputFields.length).fill([])); // Initialize suggestions as an array of empty arrays

    const [selectedItemIndex, setSelectedItemIndex] = useState(-1);

    const handleChangeItemDescriptionMN = (index) => (e) => {
        const newValue = e.target.value;
        setInputFields((prevInputFields) => {

            const updatedFields = [...prevInputFields];

            updatedFields[index].itemDescription = newValue;

            const inputText = newValue.toLowerCase();

            let filteredSuggestions = sales_itemDescription_forManualEntryList.filter((item) =>
                item.itemDescription && item.itemDescription.toLowerCase().includes(inputText)
            );

            // setSuggestions(filteredSuggestions, index);
            // setSelectedItemIndex(-1);

            updatedFields[index].suggestions = filteredSuggestions

            handleMultipleCalculation(
                updatedFields[index]?.rate || 0,
                updatedFields[index]?.quantity || 0,
                updatedFields[index]?.discountPer || 0,
                updatedFields[index]?.gst || 0,
                index
            );

            return updatedFields;

        });

    };

    const handleSuggestionClick = (suggestion, index) => {
        setInputFields((prevInputFields) => {
            const updatedFields = [...prevInputFields];
            updatedFields[index] = {
                ...updatedFields[index],
                itemDescription: suggestion,
                suggestions: [], // Clear suggestions
                selectedItemIndex: -1, // Reset selectedItemIndex
            }
            return updatedFields;
        });
        setIsUpdateArray(!isUpdateArray);
        setSuggestions([]);
        setSelectedItemIndex(-1);
    };

    const handleChangeUnit = (index) => (event, newValue) => {
        setInputFields((prevInputFields) => {
            const updatedFields = [...prevInputFields];
            updatedFields[index].unit = newValue;
            return updatedFields;
        })
    }

    const handleChangeItemDescription = (index) => (event, newValue) => {

        const updatedInputFields = inputFields.map((row, ind) => {
            const newGST = invoiceSetting && invoiceSetting.showGstPer_details === 'true' ? newValue.gst : row.gst
            if (ind === index) {
                handleMultipleCalculation(
                    newValue?.rate || 0,
                    parseFloat(row.quantity) || 0,
                    parseFloat(row.discountPer) || 0,
                    parseFloat(newGST) || 0,
                    index
                );

                const selecetedRate = newValue === null ? null : parseFloat(newValue.rate);
                const bsAmount = selecetedRate * parseFloat(row.quantity);
                const disAmt = ((bsAmount * parseFloat(row.discountPer)) / 100).toFixed(2);
                const assAmt = parseFloat(bsAmount - disAmt);
                const gstAmt = ((assAmt * parseFloat(newGST)) / 100).toFixed(2);
                const totalAmt = (parseFloat(assAmt) + parseFloat(gstAmt)).toFixed(2);

                const loginState = convertStringIntoTitleCase(userInfo.state);
                const cgstPer = (customerName.state === loginState) ? (parseFloat(newGST)) / 2 : 0;
                const sgstPer = (customerName.state === loginState) ? (parseFloat(newGST)) / 2 : 0;
                const igstPer = (customerName.state === loginState) ? 0 : (parseFloat(newGST));

                const cgstAmt = (assAmt * parseFloat(cgstPer)) / 100;
                const sgstAmt = (assAmt * parseFloat(sgstPer)) / 100;
                const igstAmt = (assAmt * parseFloat(igstPer)) / 100;

                return {
                    ...row,
                    itemId: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue,
                    itemDescription: invoiceSetting.itemThroughManualEntry === 'true' ? newValue === null ? null : newValue.itemDescription : null,
                    itemCode: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue === null ? null : newValue.itemCode,
                    itemName: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue === null ? null : newValue.itemName,
                    hsnCode: newValue === null ? null : newValue.hsnCode,
                    unit: newValue === null ? null : newValue,
                    rate: newValue === null ? null : newValue.rate,
                    quantity: row.quantity,
                    discountPer: row.discountPer,
                    basicAmount: bsAmount,
                    assessableAmt: assAmt,
                    amount: totalAmt,
                    discountAmt: disAmt,
                    noOfPkg: '',
                    batchNo: '',
                    gst: newGST,
                    cgst: cgstPer,
                    sgst: sgstPer,
                    igst: igstPer,
                    gstAmount: gstAmt,
                    cgstAmount: cgstAmt,
                    sgstAmount: sgstAmt,
                    igstAmount: igstAmt,

                };

            }
            return row;
        });

        setInputFields(updatedInputFields);
        setIsUpdateArray(!isUpdateArray);
    };

    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = { ...array[i] }; // Create a copy to avoid mutating the state directly

        result[e.target.name] = e.target.value;
        array[i] = result;

        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);

        if (e.target.name === 'quantity') {
            handleMultipleCalculation(
                parseFloat(result['rate']),
                parseFloat(e.target.value),
                parseFloat(result['discountPer']),
                parseFloat(result['gst']),
                i
            );
        } else if (e.target.name === 'rate') {
            handleMultipleCalculation(
                parseFloat(e.target.value),
                parseFloat(result['quantity']),
                parseFloat(result['discountPer']),
                parseFloat(result['gst']),
                i
            );
        } else if (e.target.name === 'discountPer') {
            handleMultipleCalculation(
                parseFloat(result['rate']),
                parseFloat(result['quantity']),
                parseFloat(e.target.value),
                parseFloat(result['gst']),
                i
            );
        } else if (e.target.name === 'gst') {
            handleMultipleCalculation(
                parseFloat(result['rate']),
                parseFloat(result['quantity']),
                parseFloat(result['discountPer']),
                parseFloat(e.target.value),
                i
            );
        }

    };

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
                cgstAmount: 0,
                sgstAmount: 0,
                igstAmount: 0,
                basicAmount: 0,
                assessableAmt: 0,
                amount: 0,
                noOfPkg: '',
                batchNo: '',
                discountPer: 0,
                discountAmt: 0,
            },
        ]);
    };

    const handleInvoiceCalculation = (bsAmount, custState, pkgForw, freight, tempo, other, gstPr, totalDiscPer) => {
        let basicAmt = parseFloat(bsAmount);
        const totalDiscountAmt1 = (basicAmt * parseFloat(totalDiscPer)) / 100;
        const assessAmt1 = basicAmt - totalDiscountAmt1;
        const assessableAmt1 = parseFloat(assessAmt1) + parseFloat(pkgForw) + parseFloat(freight) + parseFloat(tempo) + parseFloat(other)
        const gstAmt = (assessableAmt1 * parseFloat(gstPr)) / 100;
        const totalAmt = parseFloat(assessableAmt1) + parseFloat(gstAmt);

        const loginState = convertStringIntoTitleCase(userInfo.state);
        const cgstPer = (custState === loginState) ? (parseFloat(gstPr)) / 2 : 0;
        const sgstPer = (custState === loginState) ? (parseFloat(gstPr)) / 2 : 0;
        const igstPer = (custState === loginState) ? 0 : (parseFloat(gstPr));

        const cgstAmt = (assessableAmt1 * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assessableAmt1 * parseFloat(sgstPer)) / 100;
        const igstAmt = (assessableAmt1 * parseFloat(igstPer)) / 100;

        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);

        setGstTotal(gstAmt);
        setTotalDiscountAmt(totalDiscountAmt1);
        setAssessableAmt(assessableAmt1);
        setTotal(totalAmt);
        const roundedValue = Math.round(totalAmt);
        setRound_off(roundedValue - totalAmt);
    }

    const handleInvoiceCalculationGSTinDetails = (bsAmount, assAmount, gstAmt, cgstAmt, sgstAmt, igstAmt, pkgForw, freight, tempo, other) => {

        const totalAmt = parseFloat(assAmount) + parseFloat(cgstAmt) + parseFloat(sgstAmt) + parseFloat(igstAmt) + parseFloat(pkgForw) + parseFloat(freight) + parseFloat(tempo) + parseFloat(other)

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);
        setBasicTotal(bsAmount);
        setAssessableAmt(assAmount);
        setGstTotal(gstAmt);
        setTotal(totalAmt);
        const roundedValue = Math.round(totalAmt);
        setRound_off(roundedValue - totalAmt);
    }

    const handleMultipleCalculation = (rate, qty, discountPer, gstPercent, i) => {
        let basicAmt = parseFloat(qty) * parseFloat(rate);
        let discountAmt = (basicAmt * parseFloat(discountPer)) / 100;

        const assAmt = parseFloat(basicAmt - discountAmt);
        const gstAmt = parseFloat((assAmt * parseFloat(gstPercent)) / 100).toFixed(2);
        const totalAmt = parseFloat(parseFloat(assAmt) + parseFloat(gstAmt)).toFixed(2);

        const loginState = convertStringIntoTitleCase(userInfo.state);
        const custState = convertStringIntoTitleCase(customerName?.state);
        const cgstPer = (custState === loginState) ? (parseFloat(gstPercent)) / 2 : 0;
        const sgstPer = (custState === loginState) ? (parseFloat(gstPercent)) / 2 : 0;
        const igstPer = (custState === loginState) ? 0 : (parseFloat(gstPercent));

        const cgstAmt = (assAmt * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assAmt * parseFloat(sgstPer)) / 100;
        const igstAmt = (assAmt * parseFloat(igstPer)) / 100;

        const array = inputFields;
        let result = { ...array[i] }; // Create a copy to avoid mutating the state directly

        // Update the corresponding fields
        result['basicAmount'] = basicAmt;
        result['discountAmt'] = discountAmt;
        result['assessableAmt'] = assAmt;
        result['gstAmount'] = gstAmt;
        result['cgst'] = cgstPer;
        result['sgst'] = sgstPer;
        result['igst'] = igstPer;
        result['cgstAmount'] = cgstAmt;
        result['sgstAmount'] = sgstAmt;
        result['igstAmount'] = igstAmt;
        result['amount'] = totalAmt;

        // Update the array
        array[i] = result;

        // Set the updated array in state
        setInputFields([...array]);
        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        if (invoiceSetting.showGstPer_details === 'true') {
            const bsAmt = inputFields && inputFields.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
            const asAmt = inputFields && inputFields.map(value => value.assessableAmt && value.assessableAmt ? parseFloat(value.assessableAmt) : 0).reduce(reducer);
            const gstAmt = inputFields && inputFields.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
            const cgstA = inputFields && inputFields.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
            const sgstA = inputFields && inputFields.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
            const igstA = inputFields && inputFields.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);
            setBasicTotal(parseFloat(bsAmt));
            setAssessableAmt(parseFloat(asAmt));
            setCgstTotal(parseFloat(gstAmt));
            setCgstTotal(parseFloat(cgstA));
            setSgstTotal(parseFloat(sgstA));
            setIgstTotal(parseFloat(igstA));

            setIsUpdateArray(isUpdateArray ? false : true);
            setIsSet(isSet ? false : true)

            handleInvoiceCalculationGSTinDetails(bsAmt, asAmt, gstAmt, cgstA, sgstA, igstA, packing_forwarding, freight_charges, tempo_charges, other_charges)

        } else {
            const bsAmt = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
            setBasicTotal(parseFloat(bsAmt));
            setIsUpdateArray(isUpdateArray ? false : true);
            setIsSet(isSet ? false : true)
            handleInvoiceCalculation(bsAmt, custState, packing_forwarding, freight_charges, tempo_charges, other_charges, gst, totalDiscountPer)
        }
    }

    const handleBackButtonClick = () => {
        console.log('Current Tab:', backBtnLen);
        navigate('/sales', { state: { backBtnTab: backBtnLen } });
    };
    const navigateToAddEdit = (row) => {
        const state = {
            CNS_Type: 'Customer',
            availCNS_Type: true,
        };
        navigate('/masters/add-party-masters', { state });
    };

    const lastEntryNo = useSelector(state => state.ProformaInvoice.lastEntryNo)

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Sales', path: '/sales/' },
                        { name: 'Proforma Invoice List', path: '/sales/proforma-invoice' },
                        { name: 'Create Proforma Invoice' },
                    ]}
                />
                <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>

                    {/* <Box >
                        <Grid container spacing={0.2} sx={{ pb: 1 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create Sales Invoice</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                    <Box sx={{ m: 2 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={0} sx={{ p: 0 }}>
                                <Grid item md={6}>
                                    <Box sx={{ display: 'flex' }}>
                                        <Autocomplete sx={{ marginBottom: '10px' }}

                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerList}
                                            value={customerName}
                                            onChange={handleChangeCustomer}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Please Select Customer"
                                                sx={{
                                                    width: { sm: 400, md: 400 },
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12,
                                                    }
                                                }} {...params} />}
                                        />
                                        <AddCircleOutlineOutlinedIcon className={`${styles.addBtnEntry}`} onClick={() => navigateToAddEdit()} />
                                    </Box>
                                    {customerName &&
                                        <Card sx={{ maxWidth: 400, backgroundColor: '#f0efed', }}>
                                            <CardContent sx={{ padding: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }}> {customerName.CNS_Name}</Typography>
                                                {/* <Typography sx={{ fontSize: '11px', }}><Icon icon="arcticons:gstrings" width="14" height="12" style={{ marginRight: '7px' }} /> {customerName.gstn} </Typography> */}
                                                <Typography sx={{ fontSize: '11px' }}> <Icon icon="fa6-regular:address-card" width="12" height="12" style={{ marginRight: '8px' }} /> {customerName.address}</Typography>
                                                <Typography sx={{ fontSize: '11px' }}> {customerName.state + ","} {customerName.pinCode} </Typography>
                                            </CardContent>
                                        </Card>
                                    }

                                </Grid>
                                <Grid item md={6}>
                                    <Box >

                                        <Grid container spacing={1} >
                                            {!editData &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`} sx={{ fontWeight: 'bold', color: '#0000cc' }}> Last Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={10}>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#0000cc' }} >{lastEntryNo}</Typography>
                                                    </Grid>
                                                </>
                                            }
                                            {editData ?
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            disabled={true}
                                                            size='small'
                                                            fullWidth
                                                            name="invoiceNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={editData.invoiceNo}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={`${styles.skeleton_text}`}>
                                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}></Typography>
                                                        </div>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}> Invoice Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="invoiceDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={invoiceDate}
                                                        onChange={handleChangeInvoiceDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Challan No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="challanNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.challanNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Challan Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="challanDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={challanDate}
                                                        onChange={handleChangeChallanDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>PO No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="orderRefNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.orderRefNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>PO. Date </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="orderRefDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={orderRefDate}
                                                        onChange={handleChangePoDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'

                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            {invoiceSetting.showEWayBillNo === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>E-Way Bill No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="eWayBillNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.eWayBillNo)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showTransportMode === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Transport Mode</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="modeOfTransport"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.modeOfTransport)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showVehicleNo === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Vehicle No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="vehicleNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.vehicleNo)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showPaymentTerms === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Payment Terms (days)</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinputNo
                                                            size='small'
                                                            fullWidth
                                                            name="paymentTerms"
                                                            type="number"
                                                            onChange={handleChange}
                                                            value={(data.paymentTerms)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showAccountName === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Account Name</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="accountManagerName"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.accountManagerName)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showContactPerson === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Contact Person</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="contactPerson"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.contactPerson)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <br />
                        <Box>
                            <IconButton style={{ color: 'blue', fontSize: '28px', float: 'right' }} onClick={handleAddFields}>
                                <Icon icon="mdi:plus-box-outline" />
                            </IconButton>
                        </Box>
                        <TableContainer sx={{ overflowY: 'auto', minHeight: 140, maxHeight: 220 }}>
                            <Table sx={{ minWidth: 700, }} size='small' stickyHeader>
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} width="50%">
                                            Item Description
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Rate</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Quantity</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>Unit</StyledTableCell>
                                        {invoiceSetting.showDiscountPer_details === 'true' &&
                                            <>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Discount %</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Discount Amt</StyledTableCell>
                                            </>
                                        }
                                        {invoiceSetting.showGstPer_details === 'true' &&
                                            <>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Gst %</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Gst Amt</StyledTableCell>
                                            </>
                                        }
                                        {invoiceSetting.showNoOfPKG === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.table_head}`}>No of PKG</StyledTableCell>
                                        }
                                        {invoiceSetting.showBatchNo === 'true' &&
                                            <StyledTableCell align="left" className={`${styles.table_head}`}>Batch No</StyledTableCell>
                                        }
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Amount</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {inputFields.length > 0 && Array.isArray(inputFields) && inputFields.map((row, index) => (
                                        <>
                                            {customerName &&
                                                <StyledTableRow key={row.itemId} >
                                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                        {invoiceSetting.itemThroughManualEntry === 'true' ?
                                                            <Box key={index} style={{ position: 'relative' }}>
                                                                <ERPinput
                                                                    variant="standard"
                                                                    fullWidth
                                                                    type="text"
                                                                    value={row.itemDescription}
                                                                    InputProps={{
                                                                        required: invoiceSetting.itemThroughManualEntry === 'true' ? true : false,
                                                                    }}
                                                                    onChange={handleChangeItemDescriptionMN(index)}
                                                                />
                                                                <div style={{ position: 'absolute', top: '30px', left: '0' }}>
                                                                    {row.suggestions?.map((suggestion, i) => (
                                                                        <MenuItem
                                                                            key={i}
                                                                            className={`${styles.erp_lable}`}
                                                                            onClick={() => handleSuggestionClick(suggestion.itemDescription, index)}
                                                                        >
                                                                            {suggestion.itemDescription}
                                                                        </MenuItem>
                                                                    ))}
                                                                </div>
                                                            </Box>
                                                            :
                                                            <Autocomplete

                                                                fullWidth
                                                                classes={{
                                                                    option: classes.option,
                                                                    // paper: classes.autocompletePaper,
                                                                }}

                                                                noOptionsText={
                                                                    <span className={classes.noOptionsLabel}>No options</span>
                                                                }
                                                                options={itemList}
                                                                value={row.itemId}
                                                                onChange={handleChangeItemDescription(index)}
                                                                getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                                getOptionSelected={(option, value) => option.id === value.id}
                                                                renderInput={(params) => <ERPinput variant="standard"
                                                                    InputProps={{
                                                                        required: invoiceSetting.itemThroughManualEntry === 'true' ? false : true,
                                                                        disableUnderline: true,
                                                                    }}
                                                                    {...params} />}
                                                            />
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <ERPinput
                                                            variant="standard"
                                                            required
                                                            type="text"
                                                            name="hsnCode"
                                                            value={row.hsnCode}
                                                            size='small'
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                readOnly: invoiceSetting.itemThroughManualEntry === 'true' ? false : true,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="rate"
                                                            value={row.rate}
                                                            size='small'
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="quantity"
                                                            value={row.quantity}
                                                            size='small'
                                                            // onChange={(e) => handleChangeTable(e, index)}
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <Autocomplete
                                                            fullWidth
                                                            classes={{
                                                                option: classes.option,
                                                            }}
                                                            noOptionsText={
                                                                <span className={classes.noOptionsLabel}>No options</span>
                                                            }
                                                            options={unitList}
                                                            value={row.unit}
                                                            onChange={handleChangeUnit(index)}
                                                            getOptionLabel={(option) => option.unit}
                                                            getOptionSelected={(option, value) => option.unit === value.unit}
                                                            renderInput={(params) => <ERPinput required variant="standard"
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                {...params} />}
                                                        />
                                                    </StyledTableCell>

                                                    {invoiceSetting.showDiscountPer_details === 'true' &&
                                                        <>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="discountPer"
                                                                    value={row.discountPer}
                                                                    size='small'
                                                                    onChange={(e) => handleMultipleInput(e, index)}

                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="discountAmt"
                                                                    value={row.discountAmt}
                                                                    size='small'
                                                                    // onChange={(e) => handleMultipleInput(e, index)}
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                        </>
                                                    }

                                                    {invoiceSetting.showGstPer_details === 'true' &&
                                                        <>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="gst"
                                                                    value={row.gst}
                                                                    size='small'
                                                                    onChange={(e) => handleMultipleInput(e, index)}

                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="gstAmount"
                                                                    value={row.gstAmount}
                                                                    size='small'
                                                                    // onChange={(e) => handleMultipleInput(e, index)}
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                        </>
                                                    }


                                                    {invoiceSetting.showNoOfPKG === 'true' &&
                                                        <StyledTableCell className={`${styles.list_table_body}`}>
                                                            <ERPinputNo
                                                                variant="standard"
                                                                type="number"
                                                                name="noOfPkg"
                                                                value={row.noOfPkg}
                                                                size='small'
                                                                // onChange={(e) => handleChangeTable(e, index)}
                                                                onChange={(e) => handleMultipleInput(e, index)}
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                            />
                                                        </StyledTableCell>
                                                    }
                                                    {invoiceSetting.showBatchNo === 'true' &&
                                                        <StyledTableCell className={`${styles.list_table_body}`}>
                                                            <ERPinput
                                                                variant="standard"
                                                                type="text"
                                                                name="batchNo"
                                                                value={row.batchNo}
                                                                size='small'
                                                                onChange={(e) => handleMultipleInput(e, index)}

                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                            />
                                                        </StyledTableCell>
                                                    }
                                                    <StyledTableCell className={`${styles.list_table_body}`} align='right'>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="amount"
                                                            value={parseFloat(row.amount).toFixed(2)}
                                                            size='small'
                                                            // onChange={(e) => handleChangeTable(e, index)}
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                readOnly: true,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`} >
                                                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                            {/* <IconButton size="small" style={{ color: 'blue', fontSize: '14px' }} onClick={handleAddFields}>
                                                                <Icon icon="line-md:plus" />
                                                            </IconButton> */}
                                                            {/* {index === 0 ?
                                                                <IconButton disabled size="small" sx={{ fontSize: '12px', color: 'red' }} >
                                                                    <Icon icon={'line-md:remove'} />
                                                                </IconButton> : */}
                                                                <IconButton size="small" onClick={() => handleRemoveFields(index)} sx={{ fontSize: '12px', color: 'red' }}>
                                                                    <Icon icon={'line-md:remove'} />
                                                                </IconButton>
                                                                {/* } */}
                                                        </Box>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box >
                            <Grid container spacing={0} sx={{ mt: 1, }}>
                                <Grid item xs={6}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography className={`${styles.erp_lable}`} sx={{ marginBottom: '8px' }}> Remarks</Typography>
                                            <ERPinput
                                                sx={{
                                                    width: { sm: 100, md: 400 },
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12
                                                    }
                                                }}
                                                fullWidth
                                                type="text"
                                                name="remark"
                                                size='small'
                                                onChange={handleChange}
                                                value={(data.remark)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Accordion style={{ boxShadow: 'none' }} defaultExpanded={editid}>
                                                <AccordionSummary style={{ padding: '0px', maxWidth: '120px' }}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography sx={{ color: 'blue', fontSize: '12px', textDecoration: 'underline', padding: 'none' }}>Terms & conditions </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ padding: '0px' }} className={`${styles.custom_scrollbar}`}>
                                                    <Box className={`${styles.custom_scrollbar_content}`}>
                                                        {rowsTerms && rowsTerms.map((row, index) => {
                                                            return (
                                                                <Grid container spacing={0} sx={{ mt: 0 }}>
                                                                    <Grid item xs={12}>
                                                                        <Box style={{ display: 'flex' }}>
                                                                            <Checkbox
                                                                                sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px' }}
                                                                                size="small"
                                                                                name="trueFalse"
                                                                                value={row.trueFalse}
                                                                                defaultChecked={row.trueFalse}
                                                                                onChange={(event) => handleChangeTerms(event, index)}
                                                                            />
                                                                            {/* <Typography className={`${styles.erp_lable}`} style={{paddingRight: '10px',}}>{index + 1}. </Typography> */}
                                                                            <Typography className={`${styles.erp_lable}`} style={{ paddingBottom: '4px' }}>  {row.termsAndConditions}</Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6} >
                                    {invoiceSetting.showGstPer_details === 'true' ?
                                        <Grid container spacing={0} sx={{ mt: 1.5, }}>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '14px', }} >Basic Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            "& input": {
                                                                textAlign: "right",
                                                                fontSize: '14px',
                                                                fontWeight: 'bold',
                                                            }
                                                        }
                                                    }}
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="basicTotal"
                                                    value={parseFloat(basicTotal).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '14px', }} >Assessable Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            "& input": {
                                                                textAlign: "right",
                                                                fontSize: '14px',
                                                                fontWeight: 'bold',
                                                            }
                                                        }
                                                    }}
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="assessableAmt"
                                                    value={parseFloat(assessableAmt).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography className={`${styles.erp_lable}`} >CGST Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="cgstTotal"
                                                    value={parseFloat(cgstTotal).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography className={`${styles.erp_lable}`} >SGST Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="sgstTotal"
                                                    value={parseFloat(sgstTotal).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography className={`${styles.erp_lable}`}>IGST Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="igstTotal"
                                                    value={parseFloat(igstTotal).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>


                                            {invoiceSetting.showPackingForwarding === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="packing_forwarding_show"
                                                            value={packing_forwarding_show}
                                                            defaultChecked={packing_forwarding_show}
                                                            onChange={(event) => handleChangePacking_forwarding_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Packing & Forwarding </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="packing_forwarding"
                                                            onChange={handleChangePackingForwarding}
                                                            value={packing_forwarding}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: packing_forwarding_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showFreightCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="freight_charges_show"
                                                            value={freight_charges_show}
                                                            defaultChecked={freight_charges_show}
                                                            onChange={(event) => handleChangeFreight_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Freight Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="freight_charges"
                                                            onChange={handleChangeFreightCharges}
                                                            value={freight_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: freight_charges_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showTempoCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="tempo_charges_show"
                                                            value={tempo_charges_show}
                                                            defaultChecked={tempo_charges_show}
                                                            onChange={(event) => handleChangeTempo_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Tempo Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="tempo_charges"
                                                            onChange={handleChangeTempoCharges}
                                                            value={tempo_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: tempo_charges_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showOtherCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="other_charges_show"
                                                            value={other_charges_show}
                                                            defaultChecked={other_charges_show}
                                                            onChange={(event) => handleChangeOther_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Other Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="other_charges"
                                                            onChange={handleChangeOtherCharges}
                                                            value={other_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: other_charges_show == false ? true : false,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showRoundOff === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>Total Amount </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="total"
                                                            value={parseFloat(total).toFixed(2)}
                                                            size='small'
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>Round Off </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="round_off"
                                                            value={round_off == null ? 0 : parseFloat(round_off).toFixed(2)}
                                                            size='small'
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showRoundOff === 'true' ?
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <ERPinputNo
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 38,
                                                                    "& input": {
                                                                        textAlign: "right",
                                                                        fontSize: '22px',
                                                                        fontWeight: 'bold',
                                                                        color: '#000000'
                                                                    }
                                                                }
                                                            }}
                                                            variant="standard"
                                                            type="number"
                                                            name="total"
                                                            size='small'
                                                            onChange={handleChange}
                                                            value={parseFloat(Math.round(total)).toFixed(2)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <ERPinputNo
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 38,
                                                                    "& input": {
                                                                        textAlign: "right",
                                                                        fontSize: '22px',
                                                                        fontWeight: 'bold',
                                                                        color: '#000000'
                                                                    }
                                                                }
                                                            }}
                                                            variant="standard"
                                                            type="number"
                                                            name="total"
                                                            size='small'
                                                            onChange={handleChange}
                                                            value={parseFloat(total).toFixed(2)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                        :
                                        <Grid container spacing={0} sx={{ mt: 1.5, }}>
                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '14px', }} >Basic Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ERPinputNo
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            "& input": {
                                                                textAlign: "right",
                                                                fontSize: '14px',
                                                                fontWeight: 'bold',
                                                            }
                                                        }
                                                    }}
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="basicTotal"
                                                    onChange={handleChange}
                                                    value={parseFloat(basicTotal).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Grid>
                                            {invoiceSetting.showDiscountPer_header === 'true' &&
                                                <>

                                                    <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="discount_show"
                                                            value={discount_show}
                                                            defaultChecked={discount_show}
                                                            onChange={(event) => handleChangeDiscount_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Discount % </Typography>
                                                    </Grid>
                                                    <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="totalDiscountPer"
                                                            onChange={handleChangeTotalDiscountPer}
                                                            value={(totalDiscountPer)}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: discount_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>Discount Amount </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="totalDiscountAmt"
                                                            value={parseFloat(totalDiscountAmt).toFixed(2)}
                                                            size='small'
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }


                                            {invoiceSetting.showPackingForwarding === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="packing_forwarding_show"
                                                            value={packing_forwarding_show}
                                                            defaultChecked={packing_forwarding_show}
                                                            onChange={(event) => handleChangePacking_forwarding_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Packing & Forwarding </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="packing_forwarding"
                                                            onChange={handleChangePackingForwarding}
                                                            value={packing_forwarding}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: packing_forwarding_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showFreightCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="freight_charges_show"
                                                            value={freight_charges_show}
                                                            defaultChecked={freight_charges_show}
                                                            onChange={(event) => handleChangeFreight_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Freight Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="freight_charges"
                                                            onChange={handleChangeFreightCharges}
                                                            value={freight_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: freight_charges_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showTempoCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="tempo_charges_show"
                                                            value={tempo_charges_show}
                                                            defaultChecked={tempo_charges_show}
                                                            onChange={(event) => handleChangeTempo_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Tempo Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="tempo_charges"
                                                            onChange={handleChangeTempoCharges}
                                                            value={tempo_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: tempo_charges_show == false ? true : false,
                                                            }}
                                                        // InputProps={{
                                                        //     disableUnderline: true,
                                                        // }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showOtherCharges === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Checkbox
                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                            size="small"
                                                            name="other_charges_show"
                                                            value={other_charges_show}
                                                            defaultChecked={other_charges_show}
                                                            onChange={(event) => handleChangeOther_charges_show(event)}
                                                        />
                                                        <Typography className={`${styles.erp_lable}`}>Other Charges </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="other_charges"
                                                            onChange={handleChangeOtherCharges}
                                                            value={other_charges}
                                                            size='small'
                                                            InputProps={{
                                                                readOnly: other_charges_show == false ? true : false,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }

                                            <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '14px', marginTop: '2px' }} >Assessable Amount </Typography>
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', }}  >
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="assessableAmt"
                                                    value={parseFloat(assessableAmt).toFixed(2)}
                                                    size='small'
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                    sx={{
                                                        "& .MuiInputBase-root": {
                                                            "& input": {
                                                                marginTop: '6px',
                                                                textAlign: "right",
                                                                fontSize: '14px',
                                                                fontWeight: 'bold',
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            {invoiceSetting.showGstPer_header === 'true' &&
                                                <>
                                                    <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>GST % </Typography>
                                                    </Grid>
                                                    <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="gst"
                                                            onChange={handleChangeGST}
                                                            value={gst}
                                                            size='small'
                                                            // InputProps={{
                                                            //     disableUnderline: true,
                                                            // }}
                                                            onInput={(e) => {
                                                                const inputValue = Math.max(0, Math.min(100, parseInt(e.target.value)));
                                                                e.target.value = inputValue.toString().slice(0, 3);
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>GST Amount </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="gstTotal"
                                                            size='small'
                                                            onChange={handleChange}
                                                            value={parseFloat(gstTotal).toFixed(2)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }

                                            {/* =====================================================================
                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Typography className={`${styles.erp_lable}`}>CGST Amount </Typography>
                                    </Grid>
                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ERPinputNo
                                            variant="standard"
                                            required
                                            type="number"
                                            name="cgstTotal"
                                            size='small'
                                            onChange={handleChange}
                                            value={parseFloat(cgstTotal).toFixed(2)}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Typography className={`${styles.erp_lable}`}>SGST Amount </Typography>
                                    </Grid>
                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ERPinputNo
                                            variant="standard"
                                            required
                                            type="number"
                                            name="sgstTotal"
                                            size='small'
                                            onChange={handleChange}
                                            value={parseFloat(sgstTotal).toFixed(2)}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Typography className={`${styles.erp_lable}`}>IGST Amount </Typography>
                                    </Grid>
                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ERPinputNo
                                            variant="standard"
                                            required
                                            type="number"
                                            name="igstTotal"
                                            size='small'
                                            onChange={handleChange}
                                            value={parseFloat(igstTotal).toFixed(2)}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Grid>
                                ====================================================================== */}

                                            {invoiceSetting.showRoundOff === 'true' &&
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>Total Amount </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="total"
                                                            value={parseFloat(total).toFixed(2)}
                                                            size='small'
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Typography className={`${styles.erp_lable}`}>Round Off </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="round_off"
                                                            value={round_off == null ? 0 : parseFloat(round_off).toFixed(2)}
                                                            size='small'
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showRoundOff === 'true' ?
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <ERPinputNo
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 38,
                                                                    "& input": {
                                                                        textAlign: "right",
                                                                        fontSize: '22px',
                                                                        fontWeight: 'bold',
                                                                        color: '#000000'
                                                                    }
                                                                }
                                                            }}
                                                            variant="standard"
                                                            type="number"
                                                            name="total"
                                                            size='small'
                                                            onChange={handleChange}
                                                            value={parseFloat(Math.round(total)).toFixed(2)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                        <ERPinputNo
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 38,
                                                                    "& input": {
                                                                        textAlign: "right",
                                                                        fontSize: '22px',
                                                                        fontWeight: 'bold',
                                                                        color: '#000000'
                                                                    }
                                                                }
                                                            }}
                                                            variant="standard"
                                                            type="number"
                                                            name="total"
                                                            size='small'
                                                            onChange={handleChange}
                                                            value={parseFloat(total).toFixed(2)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    }
                                </Grid>

                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                </Button>
                                <Cancel />
                            </Box>
                        </Box>
                    </form>
                </Paper>
            </div>
            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
        </>
    )
}


export default ProformaInvoiceAdd